'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_v76ot_1";
const content = "_content_v76ot_33";
const styles = {
	root: root,
	content: content
};

const Divider = ({ height, width = "full", children, "aria-hidden": ariaHidden = void 0 }) => {
  return React__default.default.createElement("div", { role: "separator", "aria-hidden": ariaHidden, className: styles.root, style: { "--zds-internal-divider-height": `${height}px` }, "data-width": width }, children && React__default.default.createElement("span", { className: styles.content }, children));
};

exports.Divider = Divider;
//# sourceMappingURL=Divider.cjs.js.map
